import React from "react";
import styled from "styled-components";
import Marquee from "react-fast-marquee";
import JPMorgan from "../assets/jpmorgan";
import Microsoft from "../assets/microsoft";
import RenMoney from "../assets/renmoney";
import Merck from "../assets/merck";

const TrustedCompanies = () => {
  return (
    <StyledTrustedCompanies className="">
      <div className="section-wrapper home_parent_wrapper">
        <h2 className="section-head">Trusted by Top Companies</h2>
        <Marquee pauseOnHover={true}>
          <div className="company-wrapper">
            <div className="img_wrapper">
              <JPMorgan />
            </div>
            <div className="img_wrapper">
              <Microsoft />
            </div>
            <div className="img_wrapper">
              <img
                src="/images/flutterwave.svg"
                alt="flutterwave"
                width={167}
                height={35}
              />
            </div>
            <div className="img_wrapper">
              <img src="/images/payoneer.svg" alt="payoneer" width={120} />
            </div>
            <div className="img_wrapper">
              <Merck />
            </div>
            <div className="img_wrapper">
              <img src="/images/terragon.svg" alt="terragon" width={120} />
            </div>
            <div className="img_wrapper">
              <RenMoney />
            </div>
            <div className="img_wrapper">
              <img src="/images/carbon.svg" alt="carbon" width={120} />
            </div>
          </div>
        </Marquee>
      </div>
    </StyledTrustedCompanies>
  );
};

const StyledTrustedCompanies = styled.section`
  .section-wrapper {
    overflow: hidden;
    background: #f9fafb;
    padding: 8rem 0;
  }

  .section-head {
    text-align: center;
    font-weight: 700;
    font-size: 2.4rem;
    margin-bottom: 4rem;
  }

  .company-wrapper {
    display: flex;
    gap: 24px;
  }

  .company-wrapper .img_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 24px;
    height: 96px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
  }

  .company-wrapper img {
    width: 119px;
  }
`;

export default TrustedCompanies;
